import React from "react";
import webui, { BaseComponent } from "@tinqin/tinqin-web-ui";
import BannerTitle from "./banner-title/BannerTitle";
import EntityBuilder from "@tinqin/tinqin-web-ui/src/utils/EntityBuilder";
import { xssFilter } from "../../common/utils/xssFilter";

class ArticleFolderItem extends BaseComponent {
    constructor(props) {
        super(props);

        this.state = {
            textHeight: "0px"
        };

        this.text = React.createRef();
    }

    componentDidMount() {
        this.restrictText();
    }

    componentDidUpdate() {
        this.restrictText();
    }

    onClick = () => {
        this.dispatchSirenActions(["default", "click"]);
    };

    restrictText() {
        const props = this.extractProps();
        if (this.text.current && props.restricted) {
            const lineHeightStyle = window
                .getComputedStyle(this.text.current, null)
                .getPropertyValue("line-height");
            const lineHeight = parseFloat(lineHeightStyle);
            const textHeight = `${lineHeight * props.allowedLines}px`;
            if (textHeight !== this.state.textHeight) {
                this.setState({ textHeight: `${lineHeight * props.allowedLines}px` });
            }
        }
    }

    getTotalItems() {
        const dispatch = webui.getDispatchMethod();
        const { getParentPath, getEntityChildren } = webui.getActionByName("utils");
        const parentPath = getParentPath(this.props.computedBindTo);
        const childrenLength = dispatch(getEntityChildren(parentPath));
        return childrenLength.length;
    }

    extractDataProps() {
        const data = this.props.data || {};
        const siren = EntityBuilder.of(data);
        const selected = siren.getProperty("selected");
        const textEntity = siren.getChild("text");
        const titleEntity = siren.getChild("title");
        const RangeTitleEntity = siren.getChild("range-title");
        const description = textEntity.getValue();
        const title = RangeTitleEntity.getValue();
        const subtitle = titleEntity.getValue();

        return { selected, description, title, subtitle };
    }

    extractProps() {
        return webui.getUtils().extractComponentProps(this.props, {
            additionalProps: [
                "extraClasses",
                "selectedClasses",
                "variant",
                "restricted",
                "allowedLines"
            ],
            propsDefaults: {
                selectedClasses: "un-item-box-current",
                restricted: false,
                allowedLines: 2
            }
        });
    }

    render() {
        const { selected, description, title, subtitle } = this.extractDataProps();
        const props = this.extractProps();
        const total = !!this.props.config.rangeTotal ? `/ ${this.getTotalItems()}` : "";
        const selectedClasses = selected ? props.selectedClasses : "";
        const classes = `tq-text-center un-item-box ${selectedClasses} `;

        if (props.variant === "mobileTitleItem") {
            return (
                <div onClick={this.onClick} className={"un-step-box " + selectedClasses}>
                    <div className="tq-title un-title-number">
                        <span
                            className="tq-text-node tq-bold"
                            dangerouslySetInnerHTML={{ __html: xssFilter.process(title + total) }}
                        ></span>
                    </div>
                    <h3 className="tq-title un-title-step">
                        <span
                            className="tq-text-node"
                            dangerouslySetInnerHTML={{ __html: xssFilter.process(subtitle) }}
                        ></span>
                    </h3>
                </div>
            );
        } else if (props.variant === "mobileBottomItem") {
            return (
                <div
                    onClick={this.onClick}
                    className={"tq-banner un-lower-card " + selectedClasses}
                >
                    <div className="tq-panel-title">
                        <span
                            className="tq-text-node"
                            dangerouslySetInnerHTML={{ __html: xssFilter.process(title) }}
                        ></span>
                    </div>
                    <h3 className="tq-panel-title">
                        <span
                            className="tq-text-node"
                            dangerouslySetInnerHTML={{ __html: xssFilter.process(subtitle) }}
                        ></span>
                    </h3>
                </div>
            );
        }

        const textStyle = props.restricted
            ? { height: this.state.textHeight, overflow: "hidden" }
            : {};

        return (
            <div className={classes + " tq-panel tq-banner  tq-clickable"} onClick={this.onClick}>
                <div className="tq-banner-content">
                    <BannerTitle title={title} titleSize="L" tag="div" />
                    <BannerTitle title={subtitle} tag="h3" />
                    {description && (
                        <div className="tq-banner-description">
                            <span
                                ref={this.text}
                                style={textStyle}
                                dangerouslySetInnerHTML={{ __html: xssFilter.process(description) }}
                                className={"tq-text-node"}
                            />
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

export default webui.connectComponent({
    actions: {
        dispatchSirenActions: "siren.dispatchSirenActions"
    }
})(ArticleFolderItem);
